function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m29.7722 40.9443c-2.2562-.3878-4.1728-1.5152-5.7198-3.1976-3.8718-4.2127-5.0247-11.7801-4.6176-17.298.2136-2.9057 1.3321-5.0898 2.7851-6.6881 1.8459-2.0299 4.7108-3.6127 7.5409-3.6127v-9.0896h3.8826v9.0896c2.8302 0 5.6945 1.5826 7.5406 3.6129 1.453 1.5983 2.5715 3.7825 2.7853 6.6883.4059 5.518-.7464 13.0858-4.6186 17.2982-1.5388 1.6738-3.4518 2.8038-5.6959 3.1944v5.2721h-3.8826zm-6.0704-22.2252h6.059 9.9413c-1.2464-3.6282-4.2886-4.8465-7.9145-4.8529-3.6914-.0065-6.8064 1.1273-8.0858 4.8529zm16.4685 3.8826h-16.9368c-.0021 2.1728.2535 4.514.8172 6.6882.7229 2.7876 2.1705 6.1361 4.9644 7.4026 1.5764.7148 3.7976.7171 5.3767-.0007 2.7913-1.2687 4.2379-4.6135 4.9606-7.4004.5639-2.1745.8197-4.5165.8179-6.6897z",
  fill: "#055168",
  fillRule: "nonzero"
});

var SvgKalastus = function SvgKalastus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: "46.5666mm",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 63.5 46.5666",
    width: "63.5mm",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKalastus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kalastus.da218408.svg";
export { ForwardRef as ReactComponent };